var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PersonalWellbeingAction, PersonalWellbeingFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { createSelector } from "@reduxjs/toolkit";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
// Create memoized selectors
var selectJobSeekerQuestionnaire = function (state) {
    return state.rootReducer.JobSeekerQuestionnaireReducer;
};
var selectUserData = function (state) { return state.rootReducer.userReducer; };
var selectQuestionnaireData = createSelector([selectJobSeekerQuestionnaire], function (questionnaire) { return ({
    personalWellbeingData: questionnaire.personalWellbeingData,
    personalWellbeingFormData: questionnaire.personalWellbeingFormData,
    status: questionnaire.status,
    success_personal_wellbeing_form: questionnaire.success_personal_wellbeing_form,
}); });
var selectLoginData = createSelector([selectUserData], function (userData) { return ({
    loginData: userData.loginData || "",
}); });
/**
 * The Personal Wellbeing Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @returns JSX.Element
 */
function PersonalWellbeingQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var _b = useSelector(selectQuestionnaireData), personalWellbeingData = _b.personalWellbeingData, personalWellbeingFormData = _b.personalWellbeingFormData, success_personal_wellbeing_form = _b.success_personal_wellbeing_form;
    var loginData = useSelector(selectLoginData).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    useEffect(function () {
        console.log("[PersonalWellbeing] Component mounted, fetching data");
        questionnaireTimer.startSection("Personal Wellbeing");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!personalWellbeingData || personalWellbeingData.length === 0) {
            dispatch(PersonalWellbeingAction());
        }
    }, [dispatch]);
    var handleFormSubmit = function (formData) {
        console.log("[PersonalWellbeing] Submitting form data:", formData);
        setIsSubmitting(true);
        questionnaireTimer.endSection("Personal Wellbeing");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] =
                typeof formData[key] === "string"
                    ? DOMPurify.sanitize(formData[key])
                    : formData[key];
            return acc;
        }, {});
        console.log("[PersonalWellbeing] Dispatching form action with sanitized data");
        dispatch(PersonalWellbeingFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        console.log("[PersonalWellbeing] Navigating back to social questionnaire");
        navigate("/questionnaire/social");
    };
    useEffect(function () {
        console.log("[PersonalWellbeing] Success status changed:", success_personal_wellbeing_form);
        if (success_personal_wellbeing_form && isSubmitting) {
            console.log("[PersonalWellbeing] Form successful, navigating to progression");
            navigate("/questionnaire/progression");
        }
    }, [success_personal_wellbeing_form, navigate, isSubmitting]);
    console.log("[PersonalWellbeing] Rendering with data:", {
        hasData: !!(personalWellbeingData === null || personalWellbeingData === void 0 ? void 0 : personalWellbeingData.length),
        hasFormData: !!Object.keys(personalWellbeingFormData || {}).length,
        success: success_personal_wellbeing_form,
    });
    return (_jsx("div", __assign({ className: "" }, { children: _jsx(QuestionnaireOrg, { title: "Personal Wellbeing", content: "In this section, please tell us about your personal wellbeing and how you feel about different aspects of your life. This will help us understand how to better support you.", data: personalWellbeingData, responses: personalWellbeingFormData, loading: !personalWellbeingData || personalWellbeingData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "personal-wellbeing-w", width: getQuestionnaireProgressWidth("personalWellbeing", getQuestionnaireAttemptVariant(quesAttemptDetails)) }) })));
}
export default PersonalWellbeingQuestionnaire;
